import React from 'react';
import { useIntl } from 'react-intl';
import Events from '@/search/hooks/events';
import Selectors from '../hooks/selectors';
import { tabComponentState } from '../state/state';
import { allowedTab, findTabByUrl } from '../layoutManagerTabs';

const WrappedTab = ({ onChange, url }) => {
  const intl = useIntl();
  const { currentUser, permissions } = Selectors.useWrappedTab();
  const search = Events.useDecodeSearchQuery('open', { code: null });
  const tab = findTabByUrl(url);
  const configuration = tabComponentState(tab, url, { intl, search });
  const { Component, className } = allowedTab(tab, { permissions, currentUser, url });

  return (
    <div
      className={`panel-identifier ide-content aridhia-tab-panel aridhia-${className}`}
      id={`P${Math.floor((Math.random() * 1e8) + 1).toString()}`}
    >
      <Component configuration={configuration} onChange={onChange} />
    </div>
  );
};

export default WrappedTab;
